<template>
    <div :class="{ 'company-logo-small': small }">
        <div class="company-logo" :class="`supplier-${id || 0}`"></div>
    </div>
</template>

<script>
export default {
    name: 'SupplierLogo',
    props: {
        id: {
            type: Number | String,
            default: 0
        },
        small: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
.company-logo {
    border: 1px solid #e8e8e8;
    border-radius: 7px;
}

.company-logo-small {
    position: relative;
    width: 84px;
    height: 38.5px;

    .company-logo {
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        transform: scale(0.7);
    }
}
</style>
